import React, { Component } from 'react';
import _ from 'lodash';
import * as QuizHelpers from '../../helpers/quiz';

class Budget extends Component {
  state = {
    animate: ''
  }

  // Skip Budget If ChildrenOnly
  componentWillMount () {
    if (this.props.quiz.fieldValues.FamilyType === 'ChildrenOnly') {
      this.props.stepMethods.nextStep();
    }
  }

  componentDidMount () {
    const p = _.clone(this.props);
    QuizHelpers.sendAnalyticsOnQuestion(`${p.route}`, 'Budget Preference');
    setTimeout(() => {
      this.setState({
        animate: 'fadeIn'
      });
    }, 600);
  }

  _handleSelectBudget (val) {
    const {quiz, stepMethods} = _.clone(this.props);
    let nextStep;

    if (quiz.fieldValues.Essential === false && quiz.fieldValues.Medicaid === false && quiz.fieldValues.Medicare === false) {
      nextStep = quiz.step + 1;
    } else if (quiz.fieldValues.Location.loc.IsWesternNY === true && quiz.fieldValues.Medicare === true) {
      // alert('WESTERN');
      nextStep = quiz.step + 6;
    } else if (quiz.fieldValues.Medicare === true) {
      // alert('JUST MEDICARE');
      nextStep = quiz.step + 5;
    } else if (quiz.fieldValues.Essential === true && quiz.fieldValues.Medicaid === true) {
      nextStep = quiz.step + 4;
    } else if (quiz.fieldValues.Essential === false && quiz.fieldValues.Medicaid === true) {
      nextStep = quiz.step + 3;
    } else {
      nextStep = quiz.step + 1;
    }

    this.props.reducer(val);
    stepMethods.setStep(nextStep);
  }

  _prevStep () {
    window.history.go(-1);
  }

  render () {
    return (
      <section className={'p30 text-center animate ' + this.state.animate}>
        <div className='wrap'>
          <h3>When you think about your budget, which best describes&nbsp;{this.props.type === 'family' ? 'your family' : 'you'}?</h3>
          <div className='radio two form'>
            <input type='radio' name='budget' value='high'
              id='high'
            /><label htmlFor='high'
              onClick={(e) => (this._handleSelectBudget(1))}>{this.props.type === 'family' ? 'We' : 'I'} prefer a <strong>lower monthly payment</strong> even if it means {this.props.type === 'family' ? 'we' : 'I'} have to pay more when {this.props.type === 'family' ? "we're" : "I'm"} receiving care.</label>
            <input type='radio' name='budget' value='low'
              id='low'
            /><label
              htmlFor='low'
              onClick={(e) => (this._handleSelectBudget(2))}>{this.props.type === 'family' ? 'We' : 'I'} prefer <strong>lower, more predictable costs when {this.props.type === 'family' ? 'we' : 'I'} receive care</strong>, even if it means a higher monthly payment.</label>
            <button className='btn back' onClick={this._prevStep}>Previous</button>
          </div>
        </div>
      </section>
    );
  }
}

export default Budget;



// WEBPACK FOOTER //
// ./src/components/Questions/Budget.jsx